import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  IconButton,
  List,
  ListItem,
  Drawer,
  Avatar,
  Typography,
  Portal,
  Divider,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Link
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import LibraryBooksOutlinedIcon from "@material-ui/icons/LibraryBooksOutlined";
import PeopleOutlinedIcon from "@material-ui/icons/PeopleOutlined";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import AccountBalanceOutlinedIcon from "@material-ui/icons/AccountBalanceOutlined";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import LabelOutlinedIcon from "@material-ui/icons/LabelOutlined";
import ChatOutlinedIcon from "@material-ui/icons/ChatOutlined";
import AppsIcon from "@material-ui/icons/Apps";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import EventNoteIcon from "@material-ui/icons/EventNote";
import SchoolIcon from "@material-ui/icons/School";
import DirectionsIcon from "@material-ui/icons/DirectionsOutlined";
import LogoutIcon from "../icons/LogoutIcon";

import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { logout } from "../../store/actions/auth";
import { remCalc, capitalize } from "../../utils/helpers";
import {
  setDrawerOpenGlobal,
  setProjects,
  setActiveDialog,
  setPricingOpen,
  setApiKeys
} from "../../store/actions/account";
import logoExpanded from "../../assets/images/icons/logo_expanded.svg";
import VehiclesDialog from "./vehiclesDialog/VehiclesDialog";
import DriversDialog from "./driversDialog/DriversDialog";
import AccountDialog from "./accountDialog/AccountDialog";
import { setDrivers, resetProject } from "../../store/actions/project";
import UnsavedChangesDialog from "../dialogs/UnsavedChangesDialog";
import CodeIcon from "@material-ui/icons/Code";
import DevelopersDialog from "./developersDialog/DevelopersDialog";
import BillingDialog from "./billingDialog/BillingDialog";
import PricingDialog from "./pricing/PricingDialog";
import {
  Route,
  useRouteMatch,
  Redirect,
  useHistory,
  useLocation
} from "react-router-dom";
import { TransitionGroup } from "react-transition-group";
import { plans } from "../data/plans";
import {
  setInfoDialog,
  hideInfoDialog,
  setProjectsDisabled
} from "../../store/actions/common";
import IncompleteAcconutDrawer from "./IncompleteAccountDrawer";
import { version } from "../../../package.json";
import Skeleton from "@material-ui/lab/Skeleton";
import { LANDING_URL, rightDrawerWidth } from "../data/constants";
import CustomListItem from "./CustomListItem";
import TagsDialog from "./tagsDialog/TagsDialog";
import TemplatesDialog from "./templatesDialog/TemplatesDialog";
import AppsDialog from "./appsDialog/AppsDialog";
import { RentmanIcon } from "./appsDialog/appIcons";
import SingleApp from "./appsDialog/SingleApp";
import useProductTour from "../../states/tour/tours/product";
import RouteSetupDialog from "./routeSetupDialog/routeSetupDialog";

const useStyles = makeStyles(theme => {
  return {
    root: {
      display: "flex"
    },
    popoverRoot: {
      zIndex: "1304 !important"
    },
    drawerWrapper: {
      position: "relative",
      zIndex: 1304
    },
    drawer: {
      width: rightDrawerWidth,
      flexShrink: 0,
      whiteSpace: "nowrap"
    },
    error: {
      color: theme.palette.error.main,
      fontWeight: 500
    },
    paper: {
      border: "none",
      overflow: "hidden",
      boxShadow: "0px 0px 12px rgba(0, 0, 0, 0.16)"
    },

    drawerOpen: {
      width: rightDrawerWidth,
      transition: theme.transitions.create(["width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      }),
      "& .MuiListItem-root ": {
        borderRadius: theme.spacing(1)
      }
    },

    drawerClose: {
      transition: theme.transitions.create(["width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      }),
      width: theme.spacing(7),
      overflowY: "auto"
    },

    toolbar: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      boxSizing: "border-box",
      paddingTop: theme.spacing(1.5),
      minHeight: theme.spacing(10),
      transition: theme.transitions.create(["padding"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    bottomMenu: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      boxSizing: "border-box",
      borderTop: "1px solid #EEE",
      transition: theme.transitions.create(["padding"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    menuIcon: {
      "& svg": {
        fontSize: "24px"
      },
      [theme.breakpoints.down("md")]: {
        width: 40,
        height: 40,
        "& .MuiIconButton-label": {
          justifyContent: "center",
          alignItems: "center"
        }
      },
      "&:hover": {
        backgroundColor: "#EEE"
      }
    },
    primaryAvatar: {
      color: "#fff",
      backgroundColor: theme.palette.primary.main
    },

    listsWrapper: {
      height: "calc(100% - 222px)",
      maxHeight: "calc(100% - 222px)",
      overflowY: "auto",
      overflowX: "hidden",
      transition: theme.transitions.create(["padding"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    listSectionTitle: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
      color: "#808080",
      marginLeft: theme.spacing(1),
      marginBottom: theme.spacing(1.5),
      height: 21,
      maxHeight: 21,
      overflow: "hidden",
      transition: theme.transitions.create(
        ["height", "max-height", "margin-bottom"],
        {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen
        }
      )
    },
    listSectionTitleCollapsed: {
      height: 0,
      maxHeight: 0,
      marginBottom: 0,
      transition: theme.transitions.create(
        ["height", "max-height", "margin-bottom"],
        {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        }
      )
    },
    userName: {
      fontSize: remCalc(14),
      lineHeight: remCalc(16),
      maxWidth: remCalc(136)
    },
    companyName: {
      fontSize: remCalc(12),
      lineHeight: remCalc(14),
      fontWeight: 300,
      maxWidth: remCalc(136),
      marginTop: theme.spacing(0.25)
    },
    changePlanLink: {
      display: "block",
      textDecoration: "none",
      marginRight: theme.spacing(-1)
    },
    changePlanLinkDisabled: {
      pointerEvents: "none"
    },
    changePlanBtn: {
      fontWeight: 500,
      padding: theme.spacing(1.25, 2),
      lineHeight: remCalc(16),
      color: theme.palette.text.primary
    },
    planText: {
      fontWeight: 500,
      fontSize: remCalc(14),
      lineHeight: remCalc(16),
      marginBottom: theme.spacing(0.5)
    },
    smallText: {
      fontSize: remCalc(12),
      lineHeight: remCalc(14)
    },
    menu: {
      minWidth: remCalc(248)
    },
    link: {
      "&:hover": {
        textDecoration: "none"
      }
    },
    menuItem: {
      color: theme.palette.text.primary,
      minHeight: theme.spacing(5),
      "& .MuiListItemIcon-root": {
        minWidth: "unset"
      },
      "& svg": {
        marginRight: theme.spacing(2)
      },
      "&:hover": {
        backgroundColor: "#eee",
        "& svg": {
          color: theme.palette.text.primary
        }
      }
    },
    termsWrapper: {
      display: "flex",
      padding: theme.spacing(0.5, 2),
      "& > a:first-child": {
        marginRight: theme.spacing(1.5)
      }
    },
    menuLink: {
      color: theme.palette.secondary.main,
      fontSize: "0.875rem",
      lineHeight: "1rem",
      "&:hover": {
        textDecoration: "underline",
        backgroundColor: "transparent"
      }
    },
    divider: {
      backgroundColor: "#eee"
    },
    fontSize15pt: {
      fontSize: "0.9375rem",
      lineHeight: "1.125rem"
    },
    productTourShield: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 4
    },
    previousVersionButton: {
      padding: "0.45rem 0.85rem",
      fontSize: "0.815rem",
      textTransform: "none"
    }
  };
});

function AccountDrawer({
  logout,
  userData,
  setDrawerOpenGlobal,
  setProjects,
  expanded,
  setActiveDialog,
  activeDialog,
  setDrivers,
  setPricingOpen,
  vehiclesCount,
  payment,
  resetProject,
  setProjectsDisabled,
  incompleteAccountVisible,
  setInfoDialog,
  setApiKeys,
  apps,
  uploadStopsOpen,
  open,
  setOpen,
  saveDisabled,
  setSaveDisabled,
  organisation,
  expired,
  incompleteSubscriptionStatus,
  incompleteAccount,
  incompletePayment,
  failedToProcess,
  failedToProcessTrial,
  vehicleSettingsSetupStatus,
  visible
}) {
  const match = useRouteMatch("/payment/:planId");

  const classes = useStyles({ open });
  const history = useHistory();

  const match_payment = useRouteMatch("/payment");
  const currentPath = useRouteMatch("/:path_name");
  const location = useLocation();

  const [changesDialog, setChangesDialog] = useState({
    visible: false,
    action: () => history.replace("")
  });

  const handleDrawerOpen = () => {
    setDrawerOpenGlobal(true);
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpenGlobal(false);
    setOpen(false);
  };

  useEffect(() => {
    if (expanded !== open) {
      setDrawerOpenGlobal(expanded);
      setOpen(expanded);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Bottom popover list
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const notBusiness = organisation.plan.type !== "business";

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleClose = useCallback(() => {
    if (sessionStorage.currentProject) {
      if (uploadStopsOpen) {
        history.push(`/${sessionStorage.currentProject}/upload-stops`, {
          action: "closeDrawer"
        });
      } else {
        history.push(`/${sessionStorage.currentProject}`, {
          action: "closeDrawer"
        });
      }
    } else {
      history.push("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadStopsOpen]);

  // Warn about unsaved changes
  const warnClose = dialogName => {
    if (!saveDisabled) {
      setChangesDialog({
        visible: true,
        action: () => {
          if (currentPath && currentPath.params.path_name === dialogName) {
            handleClose();
          } else {
            history.push(`/${dialogName}`);
          }
        }
      });
    } else {
      if (
        ((currentPath && currentPath.params.path_name === dialogName) ||
          (location && location.pathname === "/" + dialogName)) &&
        // TODO: fix later, hardcode check
        !(dialogName === "apps" && location?.pathname.includes("rentman"))
      ) {
        //handleClose();
      } else {
        history.push(`/${dialogName}`);
      }
    }
  };

  const currentPlan =
    organisation &&
    organisation.plan &&
    plans.find(plan => plan.name === organisation.plan.type);

  const processingPayment = false;

  useEffect(() => {
    // handle incomplete/expired states
    if (
      failedToProcess ||
      incompleteAccount ||
      failedToProcessTrial ||
      incompletePayment ||
      processingPayment ||
      (!!expired && !match_payment)
    ) {
      setProjectsDisabled(true);
      resetProject();
    } else {
      setProjectsDisabled(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expired, incompleteAccount, incompletePayment]);

  // Product Tour
  const productTour = useProductTour();

  useEffect(() => {
    if (
      vehicleSettingsSetupStatus.completed &&
      (window.location.href.includes("start_tour=true") ||
        (organisation &&
          !expired &&
          !incompleteSubscriptionStatus &&
          (!organisation.onboarding ||
            (organisation.onboarding &&
              !organisation.onboarding.product_tour_part_1_completed &&
              !organisation.onboarding.product_tour_completed))))
    ) {
      setTimeout(() => {
        productTour.startTour();
      }, 1000);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, vehicleSettingsSetupStatus]);

  return (
    <div className={classes.root}>
      <TransitionGroup
        onTransitionEnd={e => {
          if (
            e.target &&
            e.target.parentElement &&
            e.target.parentElement.id === "projectsDialog" &&
            e.target.classList.contains("MuiPaper-root")
          ) {
            // Start tour when loading projects' dialog to create a new project
          }
        }}
      >
        <Route path="/(vehicles|payment)/">
          <VehiclesDialog
            open={!match_payment || activeDialog === "vehicles"}
            openFromPayment={activeDialog === "vehicles"}
            handleClose={handleClose}
            saveDisabled={saveDisabled}
            setActiveDialog={setActiveDialog}
            setSaveDisabled={setSaveDisabled}
          />
        </Route>

        <Route path="/drivers">
          <DriversDialog
            open={true || activeDialog === "drivers"}
            handleClose={handleClose}
            saveDisabled={saveDisabled}
            setSaveDisabled={setSaveDisabled}
          />
        </Route>

        <Route path="/tags">
          {!notBusiness ? (
            <TagsDialog
              open={true || activeDialog === "tags"}
              drawerExpanded={open}
              handleClose={handleClose}
              saveDisabled={saveDisabled}
              setSaveDisabled={setSaveDisabled}
            />
          ) : (
            <Redirect to="/" />
          )}
        </Route>

        <Route path="/notifications">
          {!notBusiness ? (
            <TemplatesDialog
              open={true || activeDialog === "notifications"}
              drawerExpanded={open}
              handleClose={handleClose}
              saveDisabled={saveDisabled}
              setSaveDisabled={setSaveDisabled}
            />
          ) : (
            <Redirect to="/" />
          )}
        </Route>

        <Route path="/apps" exact>
          {!notBusiness ? (
            <AppsDialog
              open={true}
              drawerExpanded={open}
              handleClose={handleClose}
            />
          ) : (
            <Redirect to="/" />
          )}
        </Route>

        <Route path="/apps/rentman" exact>
          {!notBusiness ? (
            <SingleApp
              appInfo={apps.find(
                app => app.name === "rentman" && app.is_available
              )}
              saveDisabled={saveDisabled}
              setSaveDisabled={setSaveDisabled}
              app="Rentman"
              open={true}
              handleClose={handleClose}
            />
          ) : (
            <Redirect to="/" />
          )}
        </Route>
        <Route path="/apps/shopify" exact>
          <SingleApp
            appInfo={apps.find(
              app => app.name === "shopify" && app.is_available
            )}
            app="Shopify"
            open={true}
            handleClose={handleClose}
          />
        </Route>
        <Route path="/apps/woocommerce" exact>
          <SingleApp
            appInfo={apps.find(
              app => app.name === "woocommerce" && app.is_available
            )}
            app="WooCommerce"
            open={true}
            handleClose={handleClose}
          />
        </Route>

        <Route path="/route-setup" exact>
          <RouteSetupDialog
            open={true}
            handleClose={handleClose}
            saveDisabled={saveDisabled}
            setSaveDisabled={setSaveDisabled}
          />
        </Route>

        <Route path="/account">
          <AccountDialog
            open={true || activeDialog === "account"}
            drawerExpanded={open}
            handleClose={handleClose}
            saveDisabled={saveDisabled}
            setSaveDisabled={setSaveDisabled}
          />
        </Route>

        <Route path="/developers">
          <DevelopersDialog
            open={true || activeDialog === "developers"}
            drawerExpanded={open}
            handleClose={handleClose}
            saveDisabled={saveDisabled}
            setSaveDisabled={setSaveDisabled}
          />
        </Route>

        <Route path="/billing">
          <BillingDialog
            open={true || activeDialog === "billing"}
            drawerExpanded={open}
            handleClose={handleClose}
            saveDisabled={saveDisabled}
            setSaveDisabled={setSaveDisabled}
          />
        </Route>
      </TransitionGroup>

      <Route path="/payment">
        {!match ? (
          <Redirect to="/payment/select-plan" />
        ) : (
          <PricingDialog
            open={true}
            drawerExpanded={open}
            setPricingOpen={setPricingOpen}
            setActiveModal={setActiveDialog}
          />
        )}
      </Route>

      <Portal>
        <Drawer
          variant="permanent"
          anchor="left"
          style={{ display: visible ? "block" : "none" }}
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open
          })}
          classes={{
            paper: clsx(classes.paper, {
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open
            }),
            root: clsx(classes.drawerWrapper, {
              // "drawer-open": open,
              // "drawer-closed": !open
            })
          }}
          open={open}
        >
          {productTour.hasActiveTourCurrently() && (
            <div className={classes.productTourShield} />
          )}
          <Box px={open ? 2 : 1} className={classes.toolbar}>
            <Box
              display="flex"
              alignItems="center"
              overflow="hidden"
              visibility={open ? "visible" : "hidden"}
              width={open ? "auto" : 0}
            >
              <Avatar className={classes.primaryAvatar}>
                {userData.fullName && userData.fullName[0]}
              </Avatar>
              <Box pl={3}>
                <Typography
                  title={userData.fullName}
                  className={classes.userName}
                  data-cy="rightMenu-user"
                  noWrap
                >
                  {userData.fullName}
                </Typography>
                <Typography
                  title={
                    userData.organisationSite &&
                    userData.organisationSite.organisation.name
                  }
                  className={classes.companyName}
                  data-cy="rightMenu-company"
                  noWrap
                >
                  {userData.organisationSite &&
                    userData.organisationSite.organisation.name}
                </Typography>
              </Box>
            </Box>
            <IconButton
              className={classes.menuIcon}
              data-cy="menuIcon"
              onClick={open ? handleDrawerClose : handleDrawerOpen}
            >
              <MenuIcon />
            </IconButton>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            flexGrow={1}
            className={classes.listsWrapper}
            px={open ? 2 : 0}
            pb={1}
          >
            <List>
              <CustomListItem
                open={open}
                IconComponent={LibraryBooksOutlinedIcon}
                text={"Projects"}
                disabled={!!match}
                active={
                  currentPath && currentPath.params.path_name === "projects"
                }
                clickHandler={() => {
                  sessionStorage.setItem("currentProject", "");
                  warnClose("projects");
                }}
              />
              <Box my={2} mx={-2}>
                <Divider className={classes.divider} />
              </Box>
              <Typography
                className={clsx(
                  classes.listSectionTitle,
                  !open && classes.listSectionTitleCollapsed
                )}
              >
                Team
              </Typography>
              <CustomListItem
                open={open}
                IconComponent={LocalShippingOutlinedIcon}
                text={"Vehicles"}
                disabled={
                  match &&
                  (!plans.some(plan => plan.link === match.params.planId) ||
                    !match.isExact ||
                    (payment &&
                      organisation &&
                      organisation.plan.type !== "free"))
                }
                // custom scenarios, if vehicle tab opened from payment section
                active={
                  currentPath?.params.path_name === "vehicles" ||
                  (match_payment && activeDialog === "vehicles")
                }
                clickHandler={
                  match_payment
                    ? () =>
                        setActiveDialog(
                          activeDialog === "vehicles" ? "" : "vehicles"
                        )
                    : () => {
                        warnClose("vehicles");
                      }
                }
              />
              <CustomListItem
                open={open}
                IconComponent={PeopleOutlinedIcon}
                text={"Drivers"}
                disabled={!!match}
                active={currentPath?.params.path_name === "drivers"}
                clickHandler={() => {
                  warnClose("drivers");
                }}
              />
              <Box my={2} mx={-2}>
                <Divider className={classes.divider} />
              </Box>
              <Typography
                className={clsx(
                  classes.listSectionTitle,
                  !open && classes.listSectionTitleCollapsed
                )}
              >
                Setup
              </Typography>
              <CustomListItem
                open={open}
                IconComponent={DirectionsIcon}
                text={"Route setup"}
                disabled={!!match}
                active={currentPath?.params.path_name === "route-setup"}
                clickHandler={() => warnClose("route-setup")}
              />
              <CustomListItem
                open={open}
                IconComponent={ChatOutlinedIcon}
                text={"Notifications"}
                notBusiness={notBusiness}
                disabled={!!match || notBusiness}
                active={currentPath?.params.path_name === "notifications"}
                clickHandler={() => warnClose("notifications")}
              />
              <CustomListItem
                open={open}
                IconComponent={LabelOutlinedIcon}
                text={"Tags"}
                notBusiness={notBusiness}
                disabled={!!match || notBusiness}
                active={currentPath?.params.path_name === "tags"}
                clickHandler={() => warnClose("tags")}
              />

              {!!apps.length && !notBusiness && (
                <>
                  <Box my={2} mx={-2}>
                    <Divider className={classes.divider} />
                  </Box>
                  <Typography
                    className={clsx(
                      classes.listSectionTitle,
                      !open && classes.listSectionTitleCollapsed
                    )}
                  >
                    Integrations
                  </Typography>
                </>
              )}
              {apps.find(app => app.name === "rentman" && app.is_available) &&
                !notBusiness && (
                  <CustomListItem
                    open={open}
                    IconComponent={RentmanIcon}
                    text={"Rentman"}
                    disabled={!!match}
                    active={location?.pathname === "/apps/rentman"}
                    clickHandler={() => warnClose("apps/rentman")}
                  />
                )}
              {/* TODO: moved to 1.10 */}

              {/* {apps.find(app => app.name === "shopify" && app.is_available) && (
                <CustomListItem
                  open={open}
                  IconComponent={ShopifyIcon}
                  text={"Shopify"}
                  disabled={!!match}
                  active={location?.pathname === "/apps/shopify"}
                  clickHandler={() => warnClose("apps/shopify")}
                />
              )} */}
              {/* {apps.find(
                app => app.name === "wooCommerce" && app.is_available
              ) && (
                <CustomListItem
                  open={open}
                  IconComponent={WoocommerceIcon}
                  text={"WooCommerce"}
                  disabled={!!match}
                  active={location?.pathname === "/apps/woocommerce"}
                  clickHandler={() => warnClose("apps/woocommerce")}
                />
              )} */}

              <Box my={2} mx={-2}>
                <Divider className={classes.divider} />
              </Box>
              <Typography
                className={clsx(
                  classes.listSectionTitle,
                  !open && classes.listSectionTitleCollapsed
                )}
              >
                Administration
              </Typography>
              <CustomListItem
                open={open}
                IconComponent={AppsIcon}
                text={"Apps"}
                notBusiness={notBusiness}
                disabled={!!match || notBusiness}
                active={
                  currentPath?.params.path_name === "apps" &&
                  ![
                    "/apps/rentman",
                    "/apps/shopify",
                    "/apps/woocommerce"
                  ].includes(location?.pathname)
                }
                clickHandler={() => warnClose("apps")}
              />
              <CustomListItem
                open={open}
                IconComponent={AccountBalanceOutlinedIcon}
                text={"Account"}
                disabled={!!match}
                active={currentPath?.params.path_name === "account"}
                clickHandler={() => warnClose("account")}
              />
              <CustomListItem
                open={open}
                IconComponent={CreditCardIcon}
                text={"Billing"}
                disabled={!!match}
                active={currentPath?.params.path_name === "billing"}
                clickHandler={() => warnClose("billing")}
              />
              <CustomListItem
                open={open}
                IconComponent={CodeIcon}
                text={"Developers"}
                disabled={!!match}
                active={currentPath?.params.path_name === "developers"}
                clickHandler={() => warnClose("developers")}
              />
            </List>
          </Box>
          <Box mt="auto">
            {open && (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                py={1}
                borderTop="1px solid #EEE"
                px={3}
              >
                <Box flexGrow={1}>
                  <Typography className={classes.planText} data-cy="planText">
                    {organisation ? (
                      <>
                        {currentPlan
                          ? currentPlan.title
                          : capitalize(organisation.plan.type)}{" "}
                        {(organisation.subscription_status === "trialing" ||
                          (organisation.subscription_status === "canceled" &&
                            !payment)) &&
                          "(Trial)"}
                      </>
                    ) : (
                      <Skeleton width="55%" />
                    )}
                  </Typography>
                  <Typography className={classes.smallText}>
                    {organisation && failedToProcess ? (
                      <span className={classes.error}>
                        Failed to process payment
                      </span>
                    ) : ["trialing", "canceled", "incomplete"].includes(
                        organisation?.subscription_status
                      ) ? (
                      expired ? (
                        <span className={classes.error}>
                          {organisation?.subscription_status === "trialing"
                            ? "Expired"
                            : "Cancelled"}
                        </span>
                      ) : !payment ? (
                        `Expires on ${new Date(
                          organisation.trial_end * 1000
                        ).toLocaleString("en-US", {
                          weekday: "long",
                          month: "short",
                          day: "2-digit"
                        })}`
                      ) : incompletePayment ? (
                        <span className={classes.error}>
                          Incomplete payment
                        </span>
                      ) : (
                        `${vehiclesCount} ${
                          vehiclesCount === 1 ? "vehicle" : "vehicles"
                        }`
                      )
                    ) : processingPayment ? (
                      <span>Processing payment</span>
                    ) : vehiclesCount ? (
                      `${vehiclesCount} ${
                        vehiclesCount === 1 ? "vehicle" : "vehicles"
                      }`
                    ) : (
                      <>
                        <Skeleton width="70%" />
                      </>
                    )}
                  </Typography>
                </Box>

                <Button
                  className={clsx(
                    classes.changePlanLink,
                    classes.changePlanBtn,
                    {
                      [classes.changePlanLinkDisabled]:
                        incompleteAccount || incompletePayment
                    }
                  )}
                  onClick={() => {
                    if (
                      match_payment ||
                      incompleteAccount ||
                      incompletePayment
                    ) {
                      return;
                    }

                    if (!saveDisabled) {
                      setChangesDialog({
                        visible: true,
                        action: () => history.push("/payment/select-plan")
                      });
                    } else {
                      history.push("/payment/select-plan");
                    }

                    // setPricingOpen(true);
                  }}
                  data-cy="modifyPlan-btn"
                  disabled={
                    !!match_payment || incompleteAccount || incompletePayment
                  }
                >
                  {organisation &&
                  ["trialing", "canceled"].includes(
                    organisation.subscription_status
                  )
                    ? "Upgrade"
                    : "Modify"}
                </Button>
                {/* </Link> */}
              </Box>
            )}
            {/* Bottom menu/logo */}
            <Box
              className={classes.bottomMenu}
              pl={open ? 3 : 1}
              pr={open ? 3 : 2}
              py={3}
            >
              <Box
                display="flex"
                alignItems="center"
                overflow="hidden"
                visibility={open ? "visible" : "hidden"}
                width={open ? "auto" : 0}
              >
                <img src={logoExpanded} alt="" />
              </Box>
              <IconButton
                style={{ marginRight: "-0.5rem" }}
                className={classes.menuIcon}
                onClick={handleMenuOpen}
                data-cy="drawerMoreBtn"
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                className={classes.popoverRoot}
                classes={{ list: classes.menu }}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                elevation={4}
                marginThreshold={24}
              >
                {/* Onboarding */}
                <MenuItem
                  onClick={() => {
                    if (!saveDisabled) {
                      setChangesDialog({
                        visible: true,
                        action: () => {
                          setDrawerOpenGlobal(false);
                          handleMenuClose();
                          setTimeout(() => {
                            productTour.startTour();
                          }, 33);
                        }
                      });
                    } else {
                      setDrawerOpenGlobal(false);
                      handleMenuClose();
                      setTimeout(() => {
                        productTour.startTour();
                      }, 33);
                    }
                  }}
                  className={classes.menuItem}
                  disabled={expired || incompleteSubscriptionStatus}
                  component={Link}
                >
                  <ListItemIcon>
                    <SchoolIcon />
                  </ListItemIcon>
                  <Typography className={classes.fontSize15pt}>
                    Product Tour
                  </Typography>
                </MenuItem>
                {/* Changelog */}
                <MenuItem
                  onClick={handleMenuClose}
                  className={classes.menuItem}
                  component={Link}
                  href={`${LANDING_URL}/changelog`}
                  target="_blank"
                >
                  <ListItemIcon>
                    <EventNoteIcon />
                  </ListItemIcon>
                  <Typography className={classes.fontSize15pt}>
                    Changelog
                  </Typography>
                </MenuItem>
                <Box mb={0.5} mt={1}>
                  <Divider className={classes.divider} />
                </Box>
                <ListItem
                  component={Typography}
                  className={classes.fontSize15pt}
                  color="textSecondary"
                  dense
                >
                  Version: {version}
                </ListItem>
                <div className={classes.termsWrapper}>
                  <Link
                    onClick={handleMenuClose}
                    className={classes.menuLink}
                    href={`${LANDING_URL}/terms`}
                    target="_blank"
                  >
                    Terms
                  </Link>
                  <Link
                    onClick={handleMenuClose}
                    className={classes.menuLink}
                    href={`${LANDING_URL}/privacy`}
                    target="_blank"
                  >
                    Privacy Policy
                  </Link>
                </div>
                <Box mb={1} mt={0.5}>
                  <Divider className={classes.divider} />
                </Box>

                <MenuItem
                  onClick={() => logout()}
                  className={clsx(classes.menuItem, classes.fontSize15pt)}
                  data-cy="logOut"
                >
                  <LogoutIcon />
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          </Box>
        </Drawer>
        <UnsavedChangesDialog
          open={changesDialog.visible}
          handleClose={() => {
            setChangesDialog({
              visible: false,
              action: () => history.push("")
            });
          }}
          action={() => {
            changesDialog.action();
            setSaveDisabled(true);
          }}
        />
      </Portal>

      {incompleteAccount && (
        <IncompleteAcconutDrawer open={incompleteAccountVisible} />
      )}
    </div>
  );
}

const mapStateToProps = state => ({
  userData: state.auth.userData,
  activeProjectId: state.project.id,
  activeDialog: state.account.accountDialog,
  pricingOpen: state.account.pricingModalOpen,
  vehiclesCount: state.project.vehicleTypes.length,
  payment: state.account.payment,
  apps: state.account.apps,
  incompleteAccountVisible: state.common.incompleteAccountVisible,
  uploadStopsOpen: state.common.uploadStopsOpen
});

export default connect(mapStateToProps, {
  logout,
  setDrawerOpenGlobal,
  setProjects,
  setActiveDialog,
  setPricingOpen,
  hideInfoDialog,
  setProjectsDisabled,
  resetProject,
  setInfoDialog,
  setDrivers,
  setApiKeys
})(AccountDrawer);
